import { render, staticRenderFns } from "./xsorderPoolList.vue?vue&type=template&id=6f7fc134&scoped=true"
import script from "./xsorderPoolList.vue?vue&type=script&lang=js"
export * from "./xsorderPoolList.vue?vue&type=script&lang=js"
import style0 from "./xsorderPoolList.vue?vue&type=style&index=0&id=6f7fc134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7fc134",
  null
  
)

export default component.exports